import { render, staticRenderFns } from "./ModalPJS.vue?vue&type=template&id=27e1b301&scoped=true&lang=pug&"
import script from "./ModalPJS.vue?vue&type=script&lang=js&"
export * from "./ModalPJS.vue?vue&type=script&lang=js&"
import style0 from "./ModalPJS.vue?vue&type=style&index=0&id=27e1b301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1b301",
  null
  
)

export default component.exports